import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components";

import { CompaniesTable } from "../components/CompaniesTable";

export const CompaniesView: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col h-full w-full">
			<PageHeader title={t("contacts.tabs.companies")} />
			<div className="w-full">
				<CompaniesTable />
			</div>
		</div>
	);
};
